export function StarIcon({
  filled,
  size = 15,
}: {
  readonly filled: boolean;
  readonly size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3l2.6 5.6 6.2.6-4.6 4.2 1.3 6.1L12 16.9l-5.5 2.6 1.3-6.1L3.2 9.2l6.2-.6z" />
    </svg>
  );
}
